/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Chat_With_UsInputs */

const en_mobile_chat_with_us = /** @type {(inputs: Mobile_Chat_With_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat with us`)
};

const es_mobile_chat_with_us = /** @type {(inputs: Mobile_Chat_With_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatea con nosotros`)
};

/**
* | output |
* | --- |
* | "Chat with us" |
*
* @param {Mobile_Chat_With_UsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_chat_with_us = /** @type {((inputs?: Mobile_Chat_With_UsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Chat_With_UsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_chat_with_us(inputs)
	return en_mobile_chat_with_us(inputs)
});